/**
 * Force a fresh load of the deployed bundle — the Cmd/Ctrl+Shift+R equivalent.
 *
 * There's no service worker here, so a plain `location.reload()` can still be served
 * from the HTTP cache. We best-effort clear the Cache Storage API entries and then
 * navigate with a cache-busting query param so the server round-trips a fresh bundle.
 * The `_reload` param is stripped again on the next mount (see UpdateProvider).
 */
export function hardReload(): void {
  try {
    if (typeof caches !== "undefined") {
      void caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k))));
    }
  } catch {
    // best-effort
  }
  const url = new URL(window.location.href);
  url.searchParams.set("_reload", Date.now().toString());
  window.location.replace(url.toString());
}
